export default {
  dialogTitle: {
    notes: 'Title of the create recommendation dialog',
    message: 'New recommendation',
  },
  assignToUser: {
    notes: 'Assign recommendation to user field',
    message: 'Assign to',
  },
  recommendToCompany: {
    notes: 'Recommend to company field',
    message: 'Recommend to',
  },
};
